import Bloks from './Bloks'
import SbEditable from 'storyblok-react'

const GlobalComponent = ({ blok }) => {
  const { global: globalBlok } = blok.reference?.content || blok || {}

  const content = globalBlok?.length
    ? globalBlok.map((childBlok) => <Bloks blok={childBlok} key={childBlok._uid} />)
    : null

  return (
    <SbEditable content={blok} key={blok._uid}>
      {content}
    </SbEditable>
  )
}

export default GlobalComponent
